import React from 'react';
import { Link } from '@material-ui/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import 'swiper/css/bundle';
import './swiperStyles.css';


const PartnersSlider = ({slides, type}) => {
  return (
    <Swiper
      modules={[Navigation, Autoplay]}
      navigation
      loop
      autoplay={{
        delay: 7000
      }}
      className="border-radius-8"
    >
      {slides.map((slide) => {
        const {_id, urlType, brandId, image} = slide;

        let url = '';

        if (urlType === 'brand') {
          url = `/${type}/${brandId}`;
        } else if (urlType === 'externalLink') {
          url = slide.externalLink;
        } else if (urlType === 'cmsIdentifier') {
          url = `/${type}/cms/${slide.cmsIdentifier}`;
        }

        return (
          <SwiperSlide key={_id}>
            <Link
              target={urlType === 'externalLink' ? '_blank' : '_self'}
              href={url}
              title={`${type} Banner`}
            >
              <img src={image} alt={`${type} Banner`} />
            </Link>
          </SwiperSlide>
        );
      })
      }
    </Swiper>
  );
};

export default PartnersSlider;
